import React from 'react';
import {
  HashRouter as Router,
  Routes,
  Route,
  Link,
  useLocation
} from 'react-router-dom';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import ContactUs from './components/ContactUs';

// Background style
const backgroundStyle = {
  minHeight: '100vh',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundColor: '#cce7ff',
  padding: '1rem',
  boxSizing: 'border-box',
};

// Nav container styles
const navStyle = {
  display: 'flex',
  gap: '1rem',
  background: 'rgba(255, 255, 255, 0.8)',
  padding: '1rem',
  borderRadius: '8px',
  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
  marginBottom: '1rem',
};

// Base link style
const linkBaseStyle = {
  textDecoration: 'none',
  padding: '8px 16px',
  borderRadius: '5px',
  color: '#333',
  fontWeight: '600',
  transition: 'background-color 0.3s ease, color 0.3s ease',
  userSelect: 'none',
};

// Active tab style
const activeLinkStyle = {
  backgroundColor: '#1976d2',
  color: '#fff',
  boxShadow: '0 2px 8px rgba(25, 118, 210, 0.5)',
};

// Hover style for non-active tabs
const hoverStyle = {
  backgroundColor: '#bbdefb',
  color: '#0d47a1',
};

const NavLink = ({ to, children }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  const [hover, setHover] = React.useState(false);

  return (
    <Link
      to={to}
      style={{
        ...linkBaseStyle,
        ...(isActive ? activeLinkStyle : {}),
        ...(hover && !isActive ? hoverStyle : {}),
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {children}
    </Link>
  );
};

const NotFound = () => (
  <div style={{ textAlign: 'center', padding: '2rem' }}>
    <h1>404</h1>
    <p>Oops! The page you're looking for doesn't exist.</p>
  </div>
);

const App = () => {
  return (
    <Router>
      <div style={backgroundStyle}>
        <nav style={navStyle}>
          <NavLink to="/">About Us</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/contact">Contact Us</NavLink>
        </nav>
        <div
          style={{
            background: 'rgba(255, 255, 255, 0.85)',
            padding: '1rem',
            borderRadius: '8px',
          }}
        >
          <Routes>
            <Route path="/" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<ContactUs />} />
            {/* Option A: Show NotFound */}
            <Route path="*" element={<NotFound />} />
            {/* Option B: Or redirect to home instead */}
            {/* <Route path="*" element={<Navigate to="/" />} /> */}
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;